import { render, staticRenderFns } from "./SideCartNew.vue?vue&type=template&id=17b4ab56&scoped=true&"
import script from "./SideCartNew.vue?vue&type=script&lang=js&"
export * from "./SideCartNew.vue?vue&type=script&lang=js&"
import style0 from "./SideCartNew.vue?vue&type=style&index=0&id=17b4ab56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b4ab56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17b4ab56')) {
      api.createRecord('17b4ab56', component.options)
    } else {
      api.reload('17b4ab56', component.options)
    }
    module.hot.accept("./SideCartNew.vue?vue&type=template&id=17b4ab56&scoped=true&", function () {
      api.rerender('17b4ab56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/SideCartNew.vue"
export default component.exports